var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoteIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/note-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "note-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M45.125 22.2501L43.0833 30.9584C41.3333 38.4792 37.875 41.5209 31.375 40.8959C30.3333 40.8126 29.2083 40.6251 28 40.3334L24.5 39.5001C15.8125 37.4376 13.125 33.1459 15.1666 24.4376L17.2083 15.7084C17.625 13.9376 18.125 12.3959 18.75 11.1251C21.1875 6.08339 25.3333 4.72922 32.2916 6.37506L35.7708 7.18756C44.5 9.22922 47.1666 13.5417 45.125 22.2501Z",
    stroke: "#083844",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M31.375 40.8958C30.0833 41.7708 28.4583 42.5 26.4791 43.1458L23.1875 44.2292C14.9166 46.8958 10.5625 44.6667 7.87498 36.3958L5.20831 28.1667C2.54165 19.8958 4.74998 15.5208 13.0208 12.8542L16.3125 11.7708C17.1666 11.5 17.9791 11.2708 18.75 11.125C18.125 12.3958 17.625 13.9375 17.2083 15.7083L15.1666 24.4375C13.125 33.1458 15.8125 37.4375 24.5 39.5L28 40.3333C29.2083 40.625 30.3333 40.8125 31.375 40.8958Z",
    stroke: "#083844",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M26.3333 18.2708L36.4374 20.8333",
    stroke: "#083844",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M24.2917 26.3333L30.3334 27.8749",
    stroke: "#083844",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteIcon);
export default __webpack_public_path__ + "static/media/note-icon.12a9b54d2dde56930d543976dc95292b.svg";
export { ForwardRef as ReactComponent };